const translations = {
  "en": {
    "Account does not exist.": "Account does not exist.",
    "Asset not found.": "Asset not found.",
    "Authorization Failed": "Authorization Failed",
    "Data is being calculated. Please try again later.": "Data is being calculated. Please try again later.",
    "Insufficient credit to activate new account": "Insufficient credit to activate new account",
    "Operation failed, please try again": "Operation failed, please try again",
    "Operation failed. Please try again later.": "Operation failed. Please try again later.",
    "Operation Too Frequent": "Operation Too Frequent",
    "Order not found.": "Order not found.",
    "Order time must be within today": "Operation failed. Only orders within 30 days can be edited.",
    "Platform id has been Bound": "Platform id has been Bound",
    "Position asset already exists.": "Position asset already exists.",
    "Position asset limit exceeded.": "Position asset limit exceeded.",
    "Position history fix failed.": "Position history fix failed.",
    "this account bind to another": "this account bind to another",
    "This specific wallet address is not bound to your account": "This specific wallet address is not bound to your account"
  },
  "zh-tw": {
    "Account does not exist.": "帳戶不存在。",
    "Asset not found.": "找不到該資產。",
    "Authorization Failed": "授權失敗",
    "Data is being calculated. Please try again later.": "資料正在計算中，請稍後重試。",
    "Insufficient credit to activate new account": "點數不足，無法啟用新帳號",
    "Operation failed, please try again": "操作失敗，請再試一次",
    "Operation failed. Please try again later.": "操作失敗。請稍後再試一次。",
    "Operation Too Frequent": "操作過於頻繁",
    "Order not found.": "未找到訂單。",
    "Order time must be within today": "操作失敗，僅支援編輯 30 天內的訂單。",
    "Platform id has been Bound": "平台 ID 已綁定",
    "Position asset already exists.": "持倉資產已存在。",
    "Position asset limit exceeded.": "持倉資產已達上限。",
    "Position history fix failed.": "持倉紀錄修正失敗。",
    "this account bind to another": "此帳號已綁定至其他帳號",
    "This specific wallet address is not bound to your account": "此錢包地址未綁定至你的帳戶"
  }
};

export default translations;
